import { render, staticRenderFns } from "./SCCardGroup.vue?vue&type=template&id=5402faba&scoped=true&"
var script = {}
import style0 from "./SCCardGroup.vue?vue&type=style&index=0&id=5402faba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5402faba",
  null
  
)

export default component.exports